<form [formGroup]="formGroup" class="grid-container">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12">
      Next, search RICS for the organization to perform the application on behalf of.<br />
      For this step, you will need at least <span class="bold">ONE</span> of the following pieces of information:
      <ul>
        <li>The Organization's RICS Owner # <span class="bold">OR</span></li>
        <li>The Organization's RBDMS # <span class="bold">OR</span></li>
        <li>The Organization's full legal name.</li>
      </ul>
      Of these options, the RICS Owner # or RBDMS # will produce the most accurate results.
    </div>
    <div class="cell large-2">
      RICS Owner #:
    </div>
    <div class="cell large-7">
      <input type="text" id="ricsNumber" formControlName="ricsNumber" />
    </div>
    <div class="cell large-3">
      <button class="button" (click)="searchRICS()" [disabled]="organizationList == null">Search by RICS Owner #</button>
    </div>
    <div class="cell large-2">
      RBDMS #:
    </div>
    <div class="cell large-7">
      <input type="text" id="rbdmsNumber" formControlName="rbdmsNumber" />
    </div>
    <div class="cell large-3">
      <button class="button" (click)="searchRBDMS()" [disabled]="organizationList == null">Search by RBDMS #</button>
    </div>
    <div class="cell large-2">
      Legal Name:
    </div>
    <div class="cell large-7">
      <input type="text" id="legalName" formControlName="legalName" />
    </div>
    <div class="cell large-3">
      <button class="button" (click)="searchNames()" [disabled]="organizationList == null">Search by Name</button>
    </div>
    <div class="cell large-12 italic">
      When searching by an organization that is registered under an individual's name, it may be best to use only the individual's last name.  Partial strings will match, and some organizations may be stored last-name-first in the case of individuals.
    </div>
    @if (organizationList == null) {
      <div class="cell large-12 minor-margin-top">
        <text-loader [run]="organizationList == null" [text]="'Loading Organizations'" [tickType]="'.'" [interval]="1000"></text-loader>
      </div>
    }
    @if (filteredList) {
      <div class="cell large-12">
        @if (filteredList.length > 0) {
          <ag-grid-angular class="data-grid "  [gridOptions]="gridOptions" [rowData]="filteredList" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="organizationChanged($event)" aria-label="On Behalf Organization Select"></ag-grid-angular>
        }
        @if (filteredList.length === 0) {
          <span class="bold">No organizations match the available search criteria.</span>
        }
      </div>
    }
    <div class="cell large-6">
      <div class="checkbox">
        <input id="newOrg" formControlName="newOrg" type="checkbox" class="show-for-sr" (click)="noMatches()" />
        <label for="newOrg">
          <span class="checkbox-box" aria-hidden="true">
            <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
          </span>
          None of the search results match the provided documentation.
        </label>
      </div>
    </div>
    <div class="cell large-6">&nbsp;</div>
    <div class="cell large-12 text-align-right">
      <button class="button margin-right" (click)="resetSearch()">Reset Search</button><button class="button" (click)="advance()" [disabled]="formGroup.invalid">Next</button>
    </div>
    @if (noODNR) {
      <div class="cell large-12 red bold">
        Applications may not be started on behalf of the Ohio Department of Natural Resources organization.
      </div>
    }
    @if (newOrganization) {
      <div class="cell large-12 red bold">
        You have indicated that this organization does not exist in RICS, and none of the RBDMS organizations presented match the organization that is required. <br />
        Only Registration paper forms are permitted to be processed in this circumstance.  Please verify that the organization is truly new to the Division before proceeding.
      </div>
    }
  </div>
</form>
